import React, { Component, Fragment } from "react";
import moment from "moment";
import GroupBarchart from "../../../../d3Components/NewBarchart/GroupBarchart";
import Spinner from "../../Datatable/spinner/spinner";
import Error from "../../Datatable/error/error";
import Legend from "../../../../d3Components/legend";
import ContainerDimensions from "react-container-dimensions";
import BrushBarChart from "../../../../d3Components/NewBarchart/BrushBarChart";
import "./styles.scss";

class BarchartHolder extends Component {
  state = {
    NewArray: [],
    splittedData: {},
    defaultSelected: "",
    _isLoaded: false,
  };
  componentDidMount() {
    let FilteredData = this.props.HistMetricsLive.map(
      ({ type, scenario_id, ...rest }) => rest
    );
    let client_FilteredData = [];
    if (this.props.client_histmetric) {
      client_FilteredData = this.props.client_histmetric.map(
        ({ type, scenario_id, ...rest }) => rest
      );
    }

    // data filtering
    this.modifyData({
      histMetrics: FilteredData,
      client_histmetrics: client_FilteredData,
    });
  }
  componentWillReceiveProps(nextProps) {
    let FilteredData = nextProps.HistMetricsLive.map(
      ({ type, scenario_id, ...rest }) => rest
    );
    let client_FilteredData = [];
    if (nextProps.client_histmetric) {
      client_FilteredData = nextProps.client_histmetric.map(
        ({ type, scenario_id, ...rest }) => rest
      );
    }

    // data filtering
    this.modifyData({
      histMetrics: FilteredData,
      client_histmetrics: client_FilteredData,
    });
  }

  modifyData = ({ histMetrics, client_histmetrics }) => {
    let monthYear = histMetrics
      .filter((d) => {
        let mt = d["metric_name"];
        return (
          mt !== moment(mt, "YYYY").format("YYYY") &&
          mt !== "YTD" &&
          mt !== "1 Year" &&
          mt !== "3 Year" &&
          mt !== "5 Year" &&
          mt !== "Since Inception"
        );
      })
      .sort((a, b) => new Date(a.metric_name) - new Date(b.metric_name));

    let monthYear2 = [];
    if (client_histmetrics) {
      monthYear2 = client_histmetrics
        .filter((d) => {
          let mt = d["metric_name"];
          return (
            mt !== moment(mt, "YYYY").format("YYYY") &&
            mt !== "YTD" &&
            mt !== "1 Year" &&
            mt !== "3 Year" &&
            mt !== "5 Year" &&
            mt !== "Since Inception"
          );
        })
        .sort((a, b) => new Date(a.metric_name) - new Date(b.metric_name));
    }
    let array2 = [];
    for (let j in monthYear) {
      let obj = {};

      (obj["portfolio"] = monthYear[j]["fund_return"] * 100),
        (obj["benchmark"] = monthYear[j]["bm_return"] * 100),
        (obj["metric_name"] = moment(
          monthYear[j].metric_name,
          "MM-YYYY"
        ).format("MMM-YYYY"));

      // if original portfolio present
      if (monthYear2.length > 0) {
        let orig_data = monthYear2.filter(
          (e) => e["metric_name"] == monthYear[j]["metric_name"]
        );
        if (orig_data.length > 0) {
          obj["Original Portfolio"] = orig_data[0]["fund_return"] * 100;
        } else if (monthYear2.length > 0) {
          obj["Original Portfolio"] = 0;
        }
      }
      array2.push(obj);
    }
    array2.sort((a, b) => new Date(a.metric_name) - new Date(b.metric_name));

    let splittedData = this.dataSplitInToThreePart({ items: array2 });

    let list = Object.keys(splittedData);
    let selected = list.slice(list.length - 1)[0];

    this.setState({
      NewArray: array2,
      splittedData,
      defaultSelected: selected,
      _isLoaded: true,
    });
  };

  dataSplitInToThreePart = ({ items }) => {
    let n = 3;
    let result = [[], [], []];

    let objPerLine = Math.ceil(items.length / n);

    for (let line = 0; line < n; line++) {
      for (let i = 0; i < objPerLine; i++) {
        const value = items[i + line * objPerLine];
        if (!value) continue; //avoid adding "undefined" values
        result[line].push(value);
      }
    }

    const _getFirst_and_LastDate = ({ list }) => {
      if (!list || list.length === 0) return "";
      let str = "";

      let firstDate = list[0]["metric_name"];
      let lastDate = list[list.length - 1]["metric_name"];

      str = `${firstDate} to ${lastDate}`;

      return str;
    };
    let obj = {};

    let d1 = _getFirst_and_LastDate({ list: result[0] });
    let d2 = _getFirst_and_LastDate({ list: result[1] });
    let d3 = _getFirst_and_LastDate({ list: result[2] });

    obj["All data"] = items;

    if (items.length > 50) {
      obj[d1] = result[0];
      obj[d2] = result[1];
      obj[d3] = result[2];
    }

    return obj;
  };

  selectionHandler = (e) => {
    const { value } = e.target;
    this.setState({
      defaultSelected: value,
    });
  };
  render() {
    const { NewArray, _isLoaded, splittedData, defaultSelected } = this.state;
    const {
      typeName,
      benchmark_name,
      display_orig_portfolio,
      model_name,
    } = this.props;
    return (
      <div className="barchartHolder">
        <div className="barchartHolder_heading">
          <h4 className="text-uppercase bold">Monthly performance</h4>
          {_isLoaded &&
          splittedData &&
          Object.keys(splittedData).length > 0 &&
          NewArray.length > 50 ? (
            <select
              className="p-all"
              value={defaultSelected}
              onChange={(e) => this.selectionHandler(e)}
            >
              {Object.keys(splittedData).map((e) => (
                <option key={e} value={e}>
                  {e}
                </option>
              ))}
            </select>
          ) : null}
        </div>
        {_isLoaded ? (
          <div className="scrollX">
            <div style={{ overflowX: "auto" }}>
              {NewArray && NewArray.length > 0 ? (
                <div>
                  <ContainerDimensions>
                    {({ width }) => (
                      <div>
                        <Legend
                          height={30}
                          width={width}
                          legend1={
                            display_orig_portfolio
                              ? `IQCIO Model ${model_name ? "+" : ""}`
                              : "Portfolio"
                          }
                          legend2={
                            display_orig_portfolio ? "Benchmark *" : typeName
                          }
                          legend3={
                            display_orig_portfolio ? "Original Portfolio" : null
                          }
                        />
                        {width > 0 ? (
                          <Fragment>
                            {NewArray.length <= 20 ? (
                              <GroupBarchart
                                containerWidth={width}
                                height={300}
                                data={NewArray}
                                targetDiv="group_bar02"
                              />
                            ) : (
                              <BrushBarChart
                                width={width}
                                height={600}
                                id="brush_bar01"
                                data={splittedData[defaultSelected]}
                              />
                            )}
                          </Fragment>
                        ) : null}
                      </div>
                    )}
                  </ContainerDimensions>
                  {display_orig_portfolio && benchmark_name ? (
                    <div>
                      <small>
                        {" "}
                        <b>*</b>&nbsp; {benchmark_name}
                      </small>
                    </div>
                  ) : null}
                  {model_name ? (
                    <div>
                      <small>
                        <b>+</b>&nbsp; {model_name}
                      </small>
                    </div>
                  ) : null}
                </div>
              ) : (
                <Error />
              )}
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

export default BarchartHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/monthlyPerformance/barchartHolder.jsx